// extracted by mini-css-extract-plugin
export default {"h1":"Heading_h1__m2iqx","h2":"Heading_h2__w2jsy","h3":"Heading_h3__Qeaxp","h5":"Heading_h5__2a2Q7"};